<template>
    <div
        :class="{
            'tiles': true,
            'tiles--loading': loadingTile,
        }"
    >
        <transition-group
            appear
            tag="div"
            :class="[ 'tiles__container', getMaxColsClass ]"
            name="tiles__item-transition"
            v-on:enter="tileEnter"
            v-on:after-leave="tileAfterLeave"
            ref="tilesContainer"
        >
            <div class="tiles__grid-sizer" key="tiles-grid-sizer" />
            <div class="tiles__gutter-sizer" key="tiles-gutter-sizer" />

            <tile-element
                v-for="item in tiles"
                :key="`tiles-item-${item.id}`"
                :item="item"
                :force-small-tile="true"
                :loading="navigatingTileIndex == item.id"
                @navigated="navigatingTileIndex = item.id"
            ></tile-element>

        </transition-group>
    </div>
</template>

<script>

import Packery from 'packery';
import debounce from 'debounce';

import TileElement from '@/components/elements/TileElement.vue';

export default {
    name: 'TilesComponent',

    components: {
        TileElement,
    },

    props: {
        tiles: {
            type: Array,
            required: true
        },
        maxCols: Number,
        loadingTile: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        getMaxColsClass() {
            return this.maxCols ? `tiles__container--max-cols-${this.maxCols}` : null;
        }
    },

    watch: {
        loadingTile(newValue, oldValue) {
            if (!newValue) {
                this.navigatingTileIndex = -1;
            }
        }
    },

    data() {
        return {
            pckry: null,
            navigatingTileIndex: -1,
        }
    },

    watch: {
        tiles(newValue, oldValue) {
            if (!!newValue.length) {
                this.initLayout();
            }
        },
    },

    mounted() {
        this.initLayout();
    },

    methods: {
        initLayout() {
            const { tilesContainer } = this.$refs;

            if (!this.pckry) {
                this.pckry = new Packery(tilesContainer.$el, {
                    columnWidth: '.tiles__grid-sizer',
                    rowHeight: '.tiles__grid-sizer',
                    itemSelector: '.tile',
                    gutter: '.tiles__gutter-sizer',
                });
            }

            this.reInitLayout();
        },

        reInitLayout() {
            if (this.pckry) {
                this.pckry.reloadItems();
                this.pckry.layout();
            }
        },

        tileEnter: debounce(function () {
            this.reInitLayout();
        }, 10),

        tileAfterLeave: debounce(function () {
            this.reInitLayout();
        }, 10),
    }
}
</script>
